// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"676300d3","977":"de167997"}[chunkId] + ".chunk.js";
};